/* eslint-disable react/jsx-no-useless-fragment */
import React, { FC } from 'react';

import { Typography } from '@mui/material';
import { Box } from '@mui/system';

import styles from './styles';

interface IFallbackComponent {
  fallbackText: string | string[];
  showFallback: boolean;
  children: React.ReactNode;
}

const FallbackComponent: FC<IFallbackComponent> = ({
  fallbackText = '',
  children,
  showFallback,
}) =>
  (
    <>
      {showFallback ? (
        <Box sx={styles.emptyContainer}>
          <Typography sx={styles.emptyText}>{fallbackText}</Typography>
        </Box>
      ) : (
        children
      )}
    </>
  );

export default FallbackComponent;
